import { render, staticRenderFns } from "./FloatingTip.vue?vue&type=template&id=487dd376&scoped=true"
import script from "./FloatingTip.vue?vue&type=script&lang=js"
export * from "./FloatingTip.vue?vue&type=script&lang=js"
import style0 from "./FloatingTip.vue?vue&type=style&index=0&id=487dd376&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "487dd376",
  null
  
)

export default component.exports